var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.427 13.011c.037-.667.363-1.254.856-1.671a2.86 2.86 0 0 1 1.844-.66c.71 0 1.36.25 1.845.66c.492.417.819 1.005.856 1.671c.038.686-.237 1.323-.721 1.795a2.83 2.83 0 0 1-1.979.782a2.83 2.83 0 0 1-1.981-.782c-.483-.472-.759-1.109-.72-1.795"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.124 14.361c.005.26.089.767.213 1.164a6.2 6.2 0 0 0 1.328 2.299a6.8 6.8 0 0 0 2.323 1.667a7.5 7.5 0 0 0 3.05.635a7.5 7.5 0 0 0 3.051-.645a6.9 6.9 0 0 0 2.321-1.675a6.2 6.2 0 0 0 1.326-2.303a5.8 5.8 0 0 0 .25-1.285a5.94 5.94 0 0 0-.888-3.594a6.5 6.5 0 0 0-1.545-1.703l.001-.001l-6.249-4.799l-.016-.014c-.411-.314-1.101-.313-1.551.002c-.457.319-.508.846-.104 1.18l-.001.001l2.606 2.121l-7.943.009h-.012c-.656 0-1.287.432-1.412.976c-.128.555.318 1.015 1.001 1.017l-.001.003l4.027-.008l-7.188 5.516l-.027.021c-.677.519-.896 1.382-.47 1.929c.434.556 1.354.556 2.04.002l3.922-3.209c.001 0-.056.433-.052.694m10.078 1.45c-.808.824-1.938 1.291-3.163 1.293c-1.226.002-2.356-.461-3.165-1.283a3.7 3.7 0 0 1-.864-1.352a3.5 3.5 0 0 1-.199-1.511c.044-.505.193-.987.434-1.422c.236-.429.562-.815.962-1.144a4.48 4.48 0 0 1 2.832-.988a4.48 4.48 0 0 1 2.832.98c.399.326.725.711.961 1.139c.24.436.39.916.434 1.421a3.5 3.5 0 0 1-.198 1.511a3.8 3.8 0 0 1-.866 1.356"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlender);
export default __webpack_public_path__ + "static/media/blender.950e5d2c09c1361039ad887636671fc8.svg";
export { ForwardRef as ReactComponent };